module.exports = "<div class=\"history-components\" hidden=\"true\">\n  <div>您上次看到<a href=\"javascript: void0;\">0.00</a>, 正在自动续播 <a href=\"javascript: void 0;\">从头开始</a></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/lesson/play/components/aliplayer/components/JumpHistoryComponent/index.html
// module id = njHI
// module chunks = 1